import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { PrivateRoute } from './components/auth/PrivateRoute';
import { LoginPage } from './pages/LoginPage';
import { ShowcasePage } from './pages/ShowcasePage';
import { TodosPage } from './pages/TodosPage';
import { TestingPage } from './pages/TestingPage';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public route - Login */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protected routes - Require authentication */}
        <Route path="/" element={
          <PrivateRoute>
            <Layout>
              <Navigate to="/todos" replace />
            </Layout>
          </PrivateRoute>
        } />

        <Route path="/showcase" element={
          <PrivateRoute>
            <Layout>
              <ShowcasePage />
            </Layout>
          </PrivateRoute>
        } />

        <Route path="/todos" element={
          <PrivateRoute>
            <Layout>
              <TodosPage />
            </Layout>
          </PrivateRoute>
        } />

        <Route path="/testing" element={
          <PrivateRoute>
            <Layout>
              <TestingPage />
            </Layout>
          </PrivateRoute>
        } />

        {/* Catch all - redirect to login */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
